import { Box } from "@chakra-ui/react";
import React from "react";

interface NormalTextProps {
  text: string;
  color?: string;
  fontSize?: string | number;
  fontWeight?: string | number;
  mb?: number | string;
}

export const NormalText: React.FC<NormalTextProps> = ({
  text,
  color = "#15161A",
  fontSize = "16px",
  fontWeight = 500,
  mb = 0,
}) => {
  return (
    <Box fontSize={fontSize} fontWeight={fontWeight} color={color} mb={mb}>
      {text}
    </Box>
  );
};
